module.exports = __webpack_public_path__ + "static/media/chalkboard.21387363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/chalkboard.jpg
// module id = 16
// module chunks = 0